var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container padding-y-md" }, [
    _c(
      "div",
      {
        staticClass: "bandana-new-pack-notice position-relative",
        staticStyle: {
          "background-color": "var(--yellow4)",
          "border-radius": "var(--border-radius-lg)",
        },
      },
      [
        _c("div", { staticStyle: { position: "relative", "z-index": "1" } }, [
          _c(
            "div",
            {
              staticClass:
                "display-flex flex-items-center flex-wrap padding-y-md padding-x-md",
            },
            [
              _c(
                "div",
                { staticClass: "display-flex flex-items-center flex-wrap" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.solid.faOpossum, size: "2x" },
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "margin-0 padding-x-md" },
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.headlineText))]),
                      _vm._v(" •\n            "),
                      _c(
                        "site-link",
                        {
                          staticClass: "primary",
                          staticStyle: {
                            "--link-color": "var(--fa-navy)",
                            "--link-hover-color": "var(--yellow9)",
                          },
                          attrs: { to: { name: "changelog" } },
                        },
                        [
                          _vm._v(
                            "\n              See what's new →\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "display-flex align-middle margin-auto laptop:margin-left-auto laptop:margin-right-0 padding-top-xs laptop:padding-0",
                },
                [
                  _vm.isActiveProPlus
                    ? _c(
                        "site-link",
                        {
                          staticClass: "button flat with-border margin-0",
                          style: _vm.ctaButtonStyle,
                          attrs: { to: _vm.$pack({ name: "graphite" }) },
                        },
                        [_vm._v("\n            Explore Graphite\n          ")]
                      )
                    : !_vm.isActivePro
                    ? _c(
                        "site-link",
                        {
                          staticClass: "button flat with-border margin-0",
                          style: _vm.ctaButtonStyle,
                          attrs: {
                            to: {
                              name: "plans.pro",
                              query: { discount: "GRAPHITE20" },
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.purchaseFlowEvent(
                                "get_pro_button_click",
                                {
                                  context: "new_release_bandana",
                                  required_pro_level: "pro",
                                  featured: "graphite",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag rounded primary margin-right-sm",
                              staticStyle: { background: "var(--fa-navy)" },
                            },
                            [_vm._v("On sale")]
                          ),
                          _vm._v("\n            Save on Pro!\n          "),
                        ]
                      )
                    : _c(
                        "site-link",
                        {
                          staticClass: "button flat with-border margin-0",
                          style: _vm.ctaButtonStyle,
                          attrs: {
                            to: {
                              name: "plans.pro-plus",
                              query: { discount: "GRAPHITE20UP" },
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.purchaseFlowEvent(
                                "get_pro_button_click",
                                {
                                  context: "new_release_bandana",
                                  required_pro_level: "plus",
                                  featured: "graphite",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "tag rounded primary margin-right-sm",
                              staticStyle: { background: "var(--fa-navy)" },
                            },
                            [_vm._v("On sale")]
                          ),
                          _vm._v("\n            Save on Pro+!\n          "),
                        ]
                      ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticStyle: {
            position: "absolute",
            inset: "0",
            "background-color": "var(--yellow5)",
            "-webkit-mask-image": "url('/images/tile-7-2.svg')",
            "-webkit-mask-repeat": "repeat",
            "-webkit-mask-size": "766px",
            "-webkit-mask-position": "center",
            "mask-image": "url('/images/tile-7-2.svg')",
            "mask-repeat": "repeat",
            "mask-size": "766px",
            "mask-position": "center",
            "pointer-events": "none",
          },
          attrs: { "aria-hidden": "true" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }